const ACCESS_TOKEN_KEY = 'zachary_crm_access_token';
const REFRESH_TOKEN_KEY = 'zachary_crm_refresh_token';
const TENANT_ID_KEY = 'zachary_crm_tenant_id';
const TOKEN_EXPIRY_KEY = 'zachary_crm_token_expiry';

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token: string): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
  // Default expiry: 1 hour from now
  const expiry = Date.now() + 60 * 60 * 1000;
  localStorage.setItem(TOKEN_EXPIRY_KEY, String(expiry));
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setRefreshToken(token: string): void {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
}

export function getTenantId(): string | null {
  return localStorage.getItem(TENANT_ID_KEY);
}

export function setTenantId(id: string): void {
  localStorage.setItem(TENANT_ID_KEY, id);
}

export function isAuthenticated(): boolean {
  const token = getAccessToken();
  if (!token) return false;

  const expiry = localStorage.getItem(TOKEN_EXPIRY_KEY);
  if (expiry && Date.now() > Number(expiry)) {
    clearAuth();
    return false;
  }

  return true;
}

export function clearAuth(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(TENANT_ID_KEY);
  localStorage.removeItem(TOKEN_EXPIRY_KEY);
}

export interface UserInfo {
  email: string;
  name: string;
}

/** Decode the JWT idToken to extract user info (email, name). */
export function getUserInfo(): UserInfo | null {
  const token = getAccessToken();
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const email = payload.email ?? '';
    // Cognito may store name in 'name' or 'cognito:username'
    const name = payload.name ?? payload['cognito:username'] ?? email;
    return { email, name };
  } catch {
    return null;
  }
}
